import { TXTWCL_Special_characters_are_not_all_ELL } from '../translations';
import type { Error } from '../types';
import { containsOnlyEnglishCharacters } from '../utils/containsOnlyEnglishCharacters';

export const mustContainOnlyEnglishCharacters =
  () =>
  (value: string): Error => ({
    valid: !!value && containsOnlyEnglishCharacters(value),
    message: TXTWCL_Special_characters_are_not_all_ELL
  });
